import { Component, Input, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { DocumentFlowComponent } from '../document-flow/document-flow.component';

@Component({
  selector: 'app-document-flow-button',
  standalone: true,
  imports: [
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  template: `
      <button 
        mat-menu-item 
        (click)="openFlowModal()"
        matTooltip="Ver Flujo de Documento"
        [disabled]="disabled">
        <mat-icon>account_tree</mat-icon>
        <span>Ver Flujo de Documento</span>
      </button>
  `
})
export class DocumentFlowButtonComponent {
  @Input({ required: true }) element!: any;
  @Input() disabled: boolean = false;
  
  private matDialog = inject(MatDialog);

  openFlowModal(): void {
    this.matDialog.open(DocumentFlowComponent, {
      panelClass: 'form-modal-flow',
      width: "95%",
      maxWidth: "1200px",
      maxHeight: "95vh",
      data: this.element,
    });
  }
}